module.exports = __webpack_public_path__ + "img/add_chart_icon.ae9bd891.svg";